import _ from "lodash";
import DefaultState from "shared/product_tabs/tab_assembly/data/DefaultState";
import { PRICE_SELECTED, QUOTED } from "pu-data/QuoteSteps";

const state = _.cloneDeep(DefaultState);

if (Spree.assembly) {
  const { quote, quote_parameters, line_item_id } = Spree.assembly;

  state.lineItemId = line_item_id;
  state.quote = quote;

  ["bga", "smt", "thru_hole", "qfn"].forEach((key) => {
    if (!quote_parameters[key]) {
      quote_parameters[key] = "0";
    }
  });

  ["lead_free", "double_sided_smt", "double_sided_tht", "class_3_inspection"].forEach((key) => {
    quote_parameters[key] = quote_parameters[key]?.toString();
  });

  state.parameters = _.assign({}, state.parameters, quote_parameters);

  state.quoteStep =
    _.isNil(state.parameters.row_selected) ||
    _.isNil(state.parameters.column_selected)
      ? QUOTED
      : PRICE_SELECTED;
} else if (Spree.fabrication) {
  // If the project doesn't include assembly, but includes fabrication take parameters from fabrication
  const { part_number, revision, filename } = Spree.fabrication.quote_parameters;
  state.parameters.part_number = part_number;
  state.parameters.revision = revision;
  state.parameters.filename = filename;
} else if (Spree.stencils && Spree.stencils.length > 0) {
  // If the project doesn't include assembly, but includes stencils take parameters from stencils
  const { parameters: stencilParameters } = Spree.stencils[0];
  let { part_number, revision, filename } = stencilParameters;

  if (part_number.endsWith("-Top Side")) {
    part_number = part_number.replace("-Top Side", "");
  } else if (part_number.endsWith("-Bottom Side")) {
    part_number = part_number.replace("-Bottom Side", "");
  } else if (part_number.endsWith("-Combine Top & Bottom")) {
    part_number = part_number.replace("-Combine Top & Bottom", "");
  }
  state.parameters.part_number = part_number;
  state.parameters.revision = revision;
  state.parameters.filename = filename;
} else if (Spree.parts) {
  // If the project doesn't include assembly, but includes parts take parameters from parts
  const { part_number, revision, zip_file } = Spree.parts;
  state.parameters.part_number = part_number;
  state.parameters.revision = revision;
  state.parameters.filename = zip_file;
}

export default state;
